import { parseStringPromise } from 'xml2js'
import { firstCharLowerCase, parseBooleans } from 'xml2js/lib/processors'
import { Dir } from '/@/shared/entities/Dir'
import { extractSDOs } from './extractors'
import { parseIndex } from './processors'

class SdoImporter {
  static async import(xmlData: string, dir: Dir) {
    const result = await parseStringPromise(xmlData, {
      tagNameProcessors: [firstCharLowerCase],
      attrNameProcessors: [firstCharLowerCase],
      valueProcessors: [parseBooleans, parseIndex],
      attrValueProcessors: [parseBooleans],
      trim: true,
      explicitArray: false,
    })

    const sdos = result?.etherCATSdos?.[Dir.sdoKey(dir)]

    if (!sdos) {
      throw new Error(`No <${Dir.sdoTag(dir)}> entries found in this file`)
    }

    return extractSDOs(sdos, Dir.linkType(dir))!
  }
}

export default SdoImporter
